import type { ReactNode } from 'react'

import { Button } from '@foxino/components-web'
import { Clipboard } from '@foxino/icons-react'

export const ToastText = ({ text, traceId }: { text: ReactNode; traceId?: string }) => {
  return (
    <div className="relative">
      {text}
      {traceId && (
        <Button
          className="absolute -top-4 right-2"
          LeadingIcon={Clipboard}
          color="quaternary"
          onClick={() => navigator.clipboard.writeText(traceId)}
        />
      )}
    </div>
  )
}
